import axiosInstance from './axiosInstance';

export default {
  create: (work_interval) => {
    return axiosInstance.post('/work_intervals', work_interval);
  },
  update: (interval_id, info) => {
    return axiosInstance.put(`/work_intervals/${interval_id}`, info);
  },
  index: () => {
    return axiosInstance.get('/users/me/work_intervals');
  },
  delete: (intervalId) => {
    return axiosInstance.delete(`/work_intervals/${intervalId}`);
  }
};
